import { create } from 'zustand'
import { IUser } from './types'

interface IAuthStore {
  user: IUser | null,
  setUser: (user: IUser) => void
  logout: () => void
}

export const useAuthStore = create<IAuthStore>((set) => ({
  user: null,
  setUser: (user: IUser) => set((state) => ({ ...state, user: user })),
  logout: () => set((state) => ({ ...state, user: null })),
}))
